import { jwtDecode } from 'jwt-decode';

const decodeJWT = (token) => {
  try {
    const decoded = jwtDecode(token);
    // Extract roles from realm_access
    const realmRoles = decoded.realm_access?.roles || [];

    if (realmRoles.includes('developer')) {        
        const realmRoles = 'developer'
        return  realmRoles ;
    }else{       
        const realmRoles = 'user'
        return  realmRoles ;
    }

  } catch (error) {
    console.error("Invalid token", error);
    return { realmRoles: [] };
  }
}

export default decodeJWT;